export default __webpack_public_path__ + "static/media/head.8bfc82cf.jpg";